<script>
export default {
  name: "SubmenuItem",
  props: {
    title: {
      type: String
    },
    buttonIcon: {
      type: String
    }
  },
}
</script>

<template>
  <div class="submenu-item-wrapper">
    {{ title }}
  </div>
</template>

<style lang="scss" scoped>
.submenu-item-wrapper {
  background: $color-white;
  color: $color-brown;
  width: 100%;
  padding: 15px 20px;
  border-radius: 30px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  font-family: $font-semi-bold;
  text-transform: uppercase;
  font-size: 13px;

  &:hover {
    background: $color-cta-main;
    color: $color-white;
    transition: 0.3s ease-in-out;
  }
}
</style>